import * as types from '_/vuex/mutation-types'

import { api } from '_/services/api'

import { errorCommit } from '_/vuex/actions/commonActions'

import { router } from '_/router/router'

import { storage } from '_/services/storage'

export default {
  /**
   * Animate function shows .sidebar, .wrapper after a small timeout to prevent flicker
   *
   * @return  {void}
   */
  animateWrapper() {
    setTimeout(() => {
      $('.sidebar, .wrapper').css('opacity', '1')
    }, 100)
  },

  /**
   * Retrieves the main menu.
   *
   * @param   {function}  options.dispatch
   * @return  {promise}
   */
  getMainMenu({ dispatch }) {
    dispatch('getMenu', {
      menuId: 1,
      mutationName: 'UI_LOAD_MAIN_MENU_SUCCESS',
    })
  },

  /**
   * Retrieves the quick launch menu.
   *
   * @param   {function}  options.dispatch
   * @return  {promise}
   */
  getQuickLaunchMenu({ dispatch }) {
    dispatch('getMenu', {
      menuId: 2,
      mutationName: 'UI_LOAD_QUICK_LAUNCH_MENU_SUCCESS',
    })
  },

  /**
   * Retrieves the menu by menuId.
   *
   * @param  {function}  options.commit
   * @param  {integer}  options.menuId
   * @param  {string}  options.mutationName
   * @return  {promise}
   */
  getMenu({ commit }, { menuId, mutationName }) {
    const payload = {
      filter: {
        system: {
          scope_id: {
            equal: menuId,
          },
        },
      },
      modules: ['menu_items'],
      sorting: {
        lft: 'asc',
      },
    }

    return api
      .post('/api/filter', payload, [], { Depth: '2' })
      .then(response => {
        let menuItemsData = response.body.body.entries
        let menuItems = { rootItems: [], childrenItems: {} }
        menuItemsData.forEach(item => {
          item = { ...item.system, ...item.fields }
          if (!item.parent_id) {
            menuItems.rootItems.push(item)
          } else {
            if (menuItems.childrenItems[item.parent_id]) {
              menuItems.childrenItems[item.parent_id].push(item)
            } else {
              menuItems.childrenItems[item.parent_id] = [item]
            }
          }
        })

        commit(types[mutationName], menuItems)
      })
      .catch(response => {
        errorCommit({ commit }, response)
      })
  },

  /**
   * Retrieves the locales
   *
   * @param  {function}  options.commit
   * @return  {promise}
   */
  getLocales({ commit }) {
    const payload = {
      sorting: {
        default: 'desc',
        lft: 'asc',
      },
      modules: ['locales'],
    }

    return api
      .post('/api/filter', payload, [], { Depth: '1' })
      .then(response => {
        let locales = response.body.body.entries.map(locale => {
          locale = { ...locale.fields, ...locale.system }
          locale.language = {
            ...locale.language.system,
            ...locale.language.fields,
          }
          return locale
        })
        commit(types.UI_SET_LOCALES, locales)
      })
      .catch(response => {
        errorCommit({ commit }, response)
      })
  },

  /**
   * Empties filtered locales
   *
   * @param  {function}  options.commit
   * @return  {void}
   */
  emptyFilteredLocales({ commit }) {
    commit(types.UI_SET_FILTERED_LOCALES, [])
  },

  /**
   * Gets filtered locales from storage
   *
   * @param  {function}  options.commit
   * @return  {void}
   */
  getFilteredLocalesFromStorage({ commit }) {
    const filteredLocales = storage.get('filteredLocales', true)

    commit(
      types.UI_SET_FILTERED_LOCALES,
      filteredLocales ? filteredLocales : []
    )
  },

  /**
   * Sets the filtered locales state property
   *
   * @param  {function}  options.commit
   * @param  {array}  options.value
   * @return  {void}
   */
  setFilteredLocales({ commit }, { value }) {
    storage.save('filteredLocales', value, true)

    commit(types.UI_SET_FILTERED_LOCALES, value)
  },

  /**
   * Retrieves the user menu.
   *
   * @param   {function}  options.dispatch
   * @return  {promise}
   */
  getUserMenu({ dispatch }) {
    dispatch('getMenu', {
      menuId: 2,
      mutationName: 'UI_LOAD_USER_MENU_SUCCESS',
    })
  },

  /**
   * Sets the class of a body HTML element
   *
   * @param  {function}  options.commit
   * @param  {string}  newBodyClass
   * @return  {void}
   */
  setBodyClass({ commit }, newBodyClass) {
    $('body').attr('class', newBodyClass)
  },

  /**
   * Sets the document title and commits the UI_SET_TITLE mutation
   *
   * @param  {function}  options.commit
   * @param  {object}  options.state
   * @param  {string}  title
   * @return  {void}
   */
  setTitle({ commit, state }, title) {
    document.title = title + ' - ' + state.photonConfig.companyTitle

    commit(types.UI_SET_TITLE, title)
  },

  /**
   * Commits the UI_SET_TITLE_SUBTEXT mutation
   *
   * @param  {function}  options.commit
   * @param  {string}  subtext
   * @return  {void}
   */
  setTitleSubtext({ commit }, subtext) {
    commit(types.UI_SET_TITLE_SUBTEXT, subtext)
  },

  /**
   * Commits the UI_SET_SHOW_SESSION_CHECKER_MODAL mutation
   *
   * @param  {function}  options.commit
   * @param  {boolean}  status
   * @return  {void}
   */
  setShowSessionCheckerModal({ commit }, status) {
    commit(types.UI_SET_SHOW_SESSION_CHECKER_MODAL, status)
  },

  /**
   * Commits the UI_SET_TITLE_ICON mutation
   *
   * @param  {function}  options.commit
   * @param  {string}  icon
   * @return  {void}
   */
  setTitleIcon({ commit }, icon) {
    commit(types.UI_SET_TITLE_ICON, icon)
  },

  /**
   * Commits the UI_BODY_RESIZE mutation to set the page body width
   *
   * @param  {function}  options.commit
   * @param  {int}  newWidth         Unit-less pixel value
   * @return  {void}
   */
  bodyResize({ commit }, newWidth) {
    commit(types.UI_BODY_RESIZE, newWidth)
  },

  /**
   * Commits the UI_UPDATE_BREADCRUMB_ITEMS mutation
   *
   * @param  {function}  options.commit
   * @param  {array}  newBreadcrumbItems Accepts an array consisting of object(s) with text and link values
   * @return  {void}
   */
  setBreadcrumbItems({ commit }, newBreadcrumbItems) {
    commit(types.UI_UPDATE_BREADCRUMB_ITEMS, newBreadcrumbItems)
  },

  /**
   * Triggers a switch to create mode by changing the route.
   *
   * @return  {void}
   */
  triggerCreateMode() {
    const currentRoute = router.app.$route.path

    // Strip trailing slashes
    let newRoute = currentRoute.replace(/\/+$/, '')

    // Strip trailing numbers
    newRoute = newRoute.replace(/\d+$/, '')

    // Strip trailing slashes again
    newRoute = newRoute.replace(/\/+$/, '')

    // Strip the '/search' suffix, if set
    newRoute = newRoute.replace(/\/search$/, '')

    // Reroute to new route
    router.push(newRoute)
  },

  /**
   * Sets the visibility of 'No entries found' text if jstree doesn't have any items to show
   *
   * @param   {function}  options.commit
   * @param   {boolean}  options.hasNodes
   * @return  {void}
   */
  updateHasNodes({ commit }, { hasNodes }) {
    commit(types.UI_UPDATE_HAS_NODES, { hasNodes })
  },
}
